import { render, staticRenderFns } from "./DontWantPaypal.vue?vue&type=template&id=2394abd4&"
import script from "./DontWantPaypal.vue?vue&type=script&lang=js&"
export * from "./DontWantPaypal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports